import { render, staticRenderFns } from "./Escolares.vue?vue&type=template&id=6b970015"
import script from "./Escolares.vue?vue&type=script&lang=js"
export * from "./Escolares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports